import {listTasks} from '../../api/tasks.js'
import {usePolling} from '../../hooks/use-polling.js'
import {TaskRow} from '../../components/task-row/task-row.jsx'
import styles from './tasks.module.scss'

export function Tasks() {
    const {data, isLoading} = usePolling({
        queryKey: ['tasks', 'me'],
        queryFn: () => listTasks({assignee: 'me'}),
        intervalMs: 30_000,
        staleTime: 30_000
    })

    const tasks = (data?.tasks || []).slice().sort((a, b) => {
        if (a.priority !== b.priority)
            return b.priority - a.priority
        const aDue = a.dueAt ? new Date(a.dueAt).getTime() : Infinity
        const bDue = b.dueAt ? new Date(b.dueAt).getTime() : Infinity
        return aDue - bDue
    })

    return (
        <div className={styles.screen}>
            <header className={styles.header}>
                <p className={styles.eyebrow}>Your queue</p>
                <h1 className={styles.title}>Tasks</h1>
            </header>
            <div className={styles.list}>
                {isLoading && Array.from({length: 3}).map((_, i) => (
                    <div key={i} className={styles.skeleton} aria-busy="true"/>
                ))}
                {!isLoading && tasks.length === 0 && (
                    <p className={styles.empty}>No assigned tasks found.</p>
                )}
                {tasks.map(task => <TaskRow key={task.id} task={task}/>)}
            </div>
        </div>
    )
}
